import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, CheckSquare, Calendar, Activity } from 'lucide-react';
export function Deliverables() {
  const items = [{
    text: 'The full 21-day plan (day-by-day structure)',
    icon: Calendar
  }, {
    text: 'Simple protein guidelines (no macros)',
    icon: Activity
  }, {
    text: 'A simple steps formula that fits real life',
    icon: Activity
  }, {
    text: 'Easy home strength routines (A/B/C format)',
    icon: Activity
  }, {
    text: 'A "bloat & belly triggers" guide (so you stop guessing)',
    icon: BookOpen
  }, {
    text: 'The Scale Is Not the Scoreboard tracking system',
    icon: CheckSquare
  }, {
    text: "The 24-Hour Reset Plan (so one bad day doesn't turn into a bad week)",
    icon: Calendar
  }, {
    text: 'Printable checklists + habit trackers',
    icon: CheckSquare
  }];
  return <section className="py-24 bg-cream-50" data-id="element-22">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-23">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-24">
          <h2 className="font-serif text-4xl text-teal-900 mb-4" data-id="element-25">
            What you'll get today
          </h2>
          <p className="text-lg text-charcoal-800" data-id="element-26">
            Everything you need to stop guessing and start resetting.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-27">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start p-4 bg-white rounded-lg border border-cream-200 shadow-sm" data-id="element-28">
              <item.icon className="w-6 h-6 text-gold-500 mr-4 flex-shrink-0 mt-1" data-id="element-29" />
              <span className="text-charcoal-900 font-medium" data-id="element-30">{item.text}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}